require(['jquery'],function () {
	var func = {
		index: function  () {
		},
		makereport: function () {
			this.changeJiao();
		},
		buyreport: function () {
			this.changeJiao();
		},
		topay: function () {
			this.radioSelected();
			this.submit();
		},
		minScreenHeight: function () {
			// 当内容不足以撑满一个屏幕的时候，修改高度，自动撑满一屏
			var changeNode = $(".minScreenHeight");
			var addHeight = $(window).height()-$(document.body).height();
			if (addHeight > 0) {
				changeNode.height(changeNode.height()+addHeight);
			}
			// 暂无订单信息就要设置行高，垂直居中
			if ($(".noOrderInfo").css("display") != "none" && $(".noOrderInfo")[0]) {
				changeNode.css("line-height",changeNode.css("height"));
			}
			$(".delayShow").css("visibility","visible");
		},
		radioSelected: function () {
			// 修改支付页面的 radio，radio用图片代替
			$(".platform label,.paySelect").click(function (e) {
				$("#radioSelected").removeAttr("id");
				$(this).parent().find("input")[0].click();
				$(this).parent().find("label").attr("id","radioSelected");
			})
		},
		changeJiao: function () {
			// 购买报告 和 定制报告的下拉菜单列表的小三角
			$(document.body).click(function () {
				if ($(".dropdown-menu").css("display") != "none") {
					$(this).find("span").removeClass("jiaoOpen").addClass("jiaoClose");
				}
			})
			$("#dropdownMenu1").click(function () {
				if ($(".dropdown-menu").css("display") == "none") {
					$(this).find("span").removeClass("jiaoClose").addClass("jiaoOpen");
				}
			})
		},
		// submit: function () {
		// 	// topay页面支付，提交时的一些 js
		// 	$("#submit").click(function () {
		// 		try {
		// 			$("#paytypeSelected").val($("#radioSelected").prev("input[type='hidden']").val());
		// 			$("#priceSubmit").val($("#price span").text());
		// 		} catch (e) {
		// 			console.error(e);
		// 			return false;
		// 		}
		// 	})
			
		// },
		payresult: function () {
			$(".minScreenHeight").css("line-height",$(".minScreenHeight").height()+"px");
			var a = setInterval(function () {
		      if ($("#time").text() > 0) {
		        $("#time").text($("#time").text()-1);
		      } else {
		      	clearInterval(a);
		        location.href = $("#toLink").attr("href") || "/home/personal/index.html";
		      }
		    },1000)
		}
	}

	
	func.minScreenHeight();
	// PS：调用 func 中的与当前页面对应的 function（根据html元素的 className 来判断）
	var str = $("html")[0].className.split("-")[1];
	if (func[str]) {
		func[str]();
	}

})


// WEBPACK FOOTER //
// ./src/pages/personal/base.js